// config.js - 환경설정 값

// Google OAuth Client ID (Web)
// TODO: Google Cloud Console에서 OAuth 2.0 Client ID(Web)를 발급받아 아래 값에 채워주세요.
export const GOOGLE_OAUTH_CLIENT_ID = '78026166-b9j90fe4euoerqv70071r10qmo5qimpp.apps.googleusercontent.com';


// Kakao Maps JavaScript API Key (JavaScript 키)
// 카카오 디벨로퍼스 > 내 애플리케이션 > 앱 키 > JavaScript 키 값을 넣어 주세요.
// 예: export const KAKAO_JAVASCRIPT_KEY = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
export const KAKAO_JAVASCRIPT_KEY = '04263909e1ab96e730a857a083271c46';

